import React from 'react';
import { ArrowRight } from 'lucide-react';
import { ARTICLES } from '../mock/mock';

export default function Articles() {
  return (
    <section id="articles" className="py-16 md:py-20">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-10 gap-4">
          <div>
            <div className="text-xs tracking-[0.3em] uppercase font-semibold mb-2" style={{ color: 'var(--gk-gold-dark)' }}>• Journal •</div>
            <h2 className="section-title text-3xl md:text-4xl">Articles from the Village</h2>
          </div>
          <a href="#" className="link-underline text-sm font-semibold inline-flex items-center gap-2" style={{ color: 'var(--gk-green-dark)' }}>View All <ArrowRight size={14} /></a>
        </div>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8">
          {ARTICLES.map(a => (
            <a key={a.id} href="#" className="group block">
              <div className="aspect-[4/3] rounded-xl overflow-hidden mb-4">
                <img src={a.img} alt={a.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
              </div>
              <h3 className="font-serif text-xl font-bold leading-snug mb-2" style={{ color: 'var(--gk-green-dark)' }}>{a.title}</h3>
              <p className="text-sm leading-relaxed mb-3" style={{ color: 'var(--gk-muted)' }}>{a.excerpt}</p>
              <span className="text-sm font-semibold link-underline" style={{ color: 'var(--gk-terracotta)' }}>Read more →</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
